export default __webpack_public_path__ + "static/media/office1full.c0b0f1cf.jpg";